import React from "react"
import { useTranslation } from "@zestia/gatsby-plugin-react-i18next"
import { graphql } from "gatsby"
import { getImage } from "gatsby-plugin-image"
import useHeadTranslation from "@/hooks/use-head-translation"
import SharedHead from "@/components/SharedHead"
import PartnerOfferTemplate from "@/components/PartnerOfferTemplate"

export const Head = props => {
  const { t } = useHeadTranslation(props)

  return (
    <SharedHead
      {...props}
      title={t("krispcall.title")}
      description={t("krispcall.description")}
      noIndex={true}
    />
  )
}

const KrispCallOfferPage = ({ data }) => {
  const { t } = useTranslation()
  const krispcallImage = getImage(data.krispcallImage)

  return (
    <PartnerOfferTemplate
      title={t("krispcall.discountTitle")}
      description={t("krispcall.discountDescription")}
      descriptionInstructions={{
        1: t("krispcall.descriptionInstructions.1"),
        2: t("krispcall.descriptionInstructions.2"),
      }}
      image={krispcallImage}
      buttonLink="https://try.krispcall.com/rjrkxttieue5"
      buttonText={t("krispcall.goToKrispCall")}
      discountCode={t("krispcall.discountCode")}
      altText={t("krispcall.altText")}
    />
  )
}

export const query = graphql`
  query {
    ...Locales
    krispcallImage: file(
      relativePath: { eq: "partners/offers/krispcall.png" }
    ) {
      childImageSharp {
        gatsbyImageData
      }
    }
  }
`

export default KrispCallOfferPage
